// extracted by mini-css-extract-plugin
export default {"content":"tooltip_content__NNm98"};